import { gql, TypedDocumentNode } from '@common/hooks';
import { FullValidationErrorFragmentType } from '@common/graphql/fragments';

export const CreateOrganizationSupplierAttachmentMutation: TypedDocumentNode<
  CreateOrganizationSupplierAttachmentMutationResponse,
  CreateOrganizationSupplierAttachmentMutationVariables
> = gql`
  mutation CreateOrganizationSupplierAttachment(
    $input: OrganizationSupplierAttachmentInput!
    $file: Upload!
    $supplierId: ID!
  ) {
    createOrganizationSupplierAttachment(
      input: $input
      file: $file
      supplierId: $supplierId
    ) {
      organizationSupplierAttachment {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

type CreateOrganizationSupplierAttachmentMutationResponse = {
  createOrganizationSupplierAttachment: {
    organizationSupplierAttachment: {
      id: string;
    } | null;
    errors: FullValidationErrorFragmentType[] | null;
  };
};

type CreateOrganizationSupplierAttachmentMutationVariables = {
  file: File;
  supplierId: string;
  input: {
    fileName: string;
    expiresOn: moment.Moment;
  };
};

export const DeleteOrganizationSupplierAttachment: TypedDocumentNode<
  DeleteOrganizationSupplierAttachmentMutationResponse,
  DeleteOrganizationSupplierAttachmentMutationVariables
> = gql`
  mutation DeleteOrganizationSupplierAttachment(
    $organizationSupplierAttachmentId: ID!
  ) {
    deleteOrganizationSupplierAttachment(
      organizationSupplierAttachmentId: $organizationSupplierAttachmentId
    ) {
      success
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export type DeleteOrganizationSupplierAttachmentMutationResponse = {
  deleteOrganizationSupplierAttachment: {
    success: boolean;
    errors: FullValidationErrorFragmentType[] | null;
  };
};

export type DeleteOrganizationSupplierAttachmentMutationVariables = {
  organizationSupplierAttachmentId: string;
};
